import { j as Ne } from "./jsx-runtime-p91LotPX.mjs";
import { p as Ve, c as pe } from "./styled-components.browser.esm-DBaC0ZEI.mjs";
import * as n from "react";
import { z as We, G as He, o as re, q as S, w as ce, U as Te, i as de, P as ge, _ as R, f as he, t as ye, a as me, g as Ae, m as Ue, u as J, Y as Be, s as Fe } from "./index-CjjiqU7h.mjs";
import { P as Xe, u as Ye, z as Ge } from "./Portal-CYsTveh8.mjs";
import { K as ie, g as be } from "./motion-P3tHGbiP.mjs";
import { p as ue } from "./pickAttrs-bNG7_x1p.mjs";
import { C as qe } from "./ContextIsolator-DZCr818D.mjs";
import { S as Ze, u as Je } from "./context-D2FhHazv.mjs";
import { u as Qe, p as Ce } from "./useClosable-DkzVjsgR.mjs";
var we = /* @__PURE__ */ n.createContext(null), ke = /* @__PURE__ */ n.createContext({}), et = ["prefixCls", "className", "containerRef"], Oe = function(t) {
  var o = t.prefixCls, a = t.className, r = t.containerRef, l = We(t, et), c = n.useContext(ke), d = c.panel, v = He(d, r);
  return /* @__PURE__ */ n.createElement("div", re({
    className: S("".concat(o, "-content"), a),
    role: "dialog",
    ref: v
  }, ue(t, {
    aria: !0
  }), {
    "aria-modal": "true"
  }, l));
};
process.env.NODE_ENV !== "production" && (Oe.displayName = "DrawerPanel");
function xe(e) {
  return typeof e == "string" && String(Number(e)) === e ? (ce(!1, "Invalid value type of `width` or `height` which should be number type instead."), Number(e)) : e;
}
function tt(e) {
  ce(!("wrapperClassName" in e), "'wrapperClassName' is removed. Please use 'rootClassName' instead."), ce(Te() || !e.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}
var Se = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none",
  position: "absolute"
};
function nt(e, t) {
  var o, a, r, l = e.prefixCls, c = e.open, d = e.placement, v = e.inline, h = e.push, w = e.forceRender, y = e.autoFocus, O = e.keyboard, i = e.classNames, m = e.rootClassName, s = e.rootStyle, D = e.zIndex, $ = e.className, P = e.id, _ = e.style, b = e.motion, p = e.width, C = e.height, M = e.children, N = e.mask, k = e.maskClosable, j = e.maskMotion, Q = e.maskClassName, B = e.maskStyle, L = e.afterOpenChange, V = e.onClose, H = e.onMouseEnter, ee = e.onMouseOver, te = e.onMouseLeave, F = e.onClick, ne = e.onKeyDown, ae = e.onKeyUp, g = e.styles, I = e.drawerRender, E = n.useRef(), z = n.useRef(), K = n.useRef();
  n.useImperativeHandle(t, function() {
    return E.current;
  });
  var W = function(x) {
    var G = x.keyCode, q = x.shiftKey;
    switch (G) {
      case ie.TAB: {
        if (G === ie.TAB) {
          if (!q && document.activeElement === K.current) {
            var Z;
            (Z = z.current) === null || Z === void 0 || Z.focus({
              preventScroll: !0
            });
          } else if (q && document.activeElement === z.current) {
            var le;
            (le = K.current) === null || le === void 0 || le.focus({
              preventScroll: !0
            });
          }
        }
        break;
      }
      case ie.ESC: {
        V && O && (x.stopPropagation(), V(x));
        break;
      }
    }
  };
  n.useEffect(function() {
    if (c && y) {
      var u;
      (u = E.current) === null || u === void 0 || u.focus({
        preventScroll: !0
      });
    }
  }, [c]);
  var oe = n.useState(!1), X = de(oe, 2), T = X[0], Y = X[1], f = n.useContext(we), se;
  typeof h == "boolean" ? se = h ? {} : {
    distance: 0
  } : se = h || {};
  var A = (o = (a = (r = se) === null || r === void 0 ? void 0 : r.distance) !== null && a !== void 0 ? a : f == null ? void 0 : f.pushDistance) !== null && o !== void 0 ? o : 180, Me = n.useMemo(function() {
    return {
      pushDistance: A,
      push: function() {
        Y(!0);
      },
      pull: function() {
        Y(!1);
      }
    };
  }, [A]);
  n.useEffect(function() {
    if (c) {
      var u;
      f == null || (u = f.push) === null || u === void 0 || u.call(f);
    } else {
      var x;
      f == null || (x = f.pull) === null || x === void 0 || x.call(f);
    }
  }, [c]), n.useEffect(function() {
    return function() {
      var u;
      f == null || (u = f.pull) === null || u === void 0 || u.call(f);
    };
  }, []);
  var Ie = N && /* @__PURE__ */ n.createElement(ge, re({
    key: "mask"
  }, j, {
    visible: c
  }), function(u, x) {
    var G = u.className, q = u.style;
    return /* @__PURE__ */ n.createElement("div", {
      className: S("".concat(l, "-mask"), G, i == null ? void 0 : i.mask, Q),
      style: R(R(R({}, q), B), g == null ? void 0 : g.mask),
      onClick: k && c ? V : void 0,
      ref: x
    });
  }), ze = typeof b == "function" ? b(d) : b, U = {};
  if (T && A)
    switch (d) {
      case "top":
        U.transform = "translateY(".concat(A, "px)");
        break;
      case "bottom":
        U.transform = "translateY(".concat(-A, "px)");
        break;
      case "left":
        U.transform = "translateX(".concat(A, "px)");
        break;
      default:
        U.transform = "translateX(".concat(-A, "px)");
        break;
    }
  d === "left" || d === "right" ? U.width = xe(p) : U.height = xe(C);
  var Ke = {
    onMouseEnter: H,
    onMouseOver: ee,
    onMouseLeave: te,
    onClick: F,
    onKeyDown: ne,
    onKeyUp: ae
  }, Le = /* @__PURE__ */ n.createElement(ge, re({
    key: "panel"
  }, ze, {
    visible: c,
    forceRender: w,
    onVisibleChanged: function(x) {
      L == null || L(x);
    },
    removeOnLeave: !1,
    leavedClassName: "".concat(l, "-content-wrapper-hidden")
  }), function(u, x) {
    var G = u.className, q = u.style, Z = /* @__PURE__ */ n.createElement(Oe, re({
      id: P,
      containerRef: x,
      prefixCls: l,
      className: S($, i == null ? void 0 : i.content),
      style: R(R({}, _), g == null ? void 0 : g.content)
    }, ue(e, {
      aria: !0
    }), Ke), M);
    return /* @__PURE__ */ n.createElement("div", re({
      className: S("".concat(l, "-content-wrapper"), i == null ? void 0 : i.wrapper, G),
      style: R(R(R({}, U), q), g == null ? void 0 : g.wrapper)
    }, ue(e, {
      data: !0
    })), I ? I(Z) : Z);
  }), ve = R({}, s);
  return D && (ve.zIndex = D), /* @__PURE__ */ n.createElement(we.Provider, {
    value: Me
  }, /* @__PURE__ */ n.createElement("div", {
    className: S(l, "".concat(l, "-").concat(d), m, he(he({}, "".concat(l, "-open"), c), "".concat(l, "-inline"), v)),
    style: ve,
    tabIndex: -1,
    ref: E,
    onKeyDown: W
  }, Ie, /* @__PURE__ */ n.createElement("div", {
    tabIndex: 0,
    ref: z,
    style: Se,
    "aria-hidden": "true",
    "data-sentinel": "start"
  }), Le, /* @__PURE__ */ n.createElement("div", {
    tabIndex: 0,
    ref: K,
    style: Se,
    "aria-hidden": "true",
    "data-sentinel": "end"
  })));
}
var Ee = /* @__PURE__ */ n.forwardRef(nt);
process.env.NODE_ENV !== "production" && (Ee.displayName = "DrawerPopup");
var De = function(t) {
  var o = t.open, a = o === void 0 ? !1 : o, r = t.prefixCls, l = r === void 0 ? "rc-drawer" : r, c = t.placement, d = c === void 0 ? "right" : c, v = t.autoFocus, h = v === void 0 ? !0 : v, w = t.keyboard, y = w === void 0 ? !0 : w, O = t.width, i = O === void 0 ? 378 : O, m = t.mask, s = m === void 0 ? !0 : m, D = t.maskClosable, $ = D === void 0 ? !0 : D, P = t.getContainer, _ = t.forceRender, b = t.afterOpenChange, p = t.destroyOnClose, C = t.onMouseEnter, M = t.onMouseOver, N = t.onMouseLeave, k = t.onClick, j = t.onKeyDown, Q = t.onKeyUp, B = t.panelRef, L = n.useState(!1), V = de(L, 2), H = V[0], ee = V[1];
  process.env.NODE_ENV !== "production" && tt(t);
  var te = n.useState(!1), F = de(te, 2), ne = F[0], ae = F[1];
  ye(function() {
    ae(!0);
  }, []);
  var g = ne ? a : !1, I = n.useRef(), E = n.useRef();
  ye(function() {
    g && (E.current = document.activeElement);
  }, [g]);
  var z = function(T) {
    var Y;
    if (ee(T), b == null || b(T), !T && E.current && !((Y = I.current) !== null && Y !== void 0 && Y.contains(E.current))) {
      var f;
      (f = E.current) === null || f === void 0 || f.focus({
        preventScroll: !0
      });
    }
  }, K = n.useMemo(function() {
    return {
      panel: B
    };
  }, [B]);
  if (!_ && !H && !g && p)
    return null;
  var W = {
    onMouseEnter: C,
    onMouseOver: M,
    onMouseLeave: N,
    onClick: k,
    onKeyDown: j,
    onKeyUp: Q
  }, oe = R(R({}, t), {}, {
    open: g,
    prefixCls: l,
    placement: d,
    autoFocus: h,
    keyboard: y,
    width: i,
    mask: s,
    maskClosable: $,
    inline: P === !1,
    afterOpenChange: z,
    ref: I
  }, W);
  return /* @__PURE__ */ n.createElement(ke.Provider, {
    value: K
  }, /* @__PURE__ */ n.createElement(Xe, {
    open: g || _ || H,
    autoDestroy: !1,
    getContainer: P,
    autoLock: s && (g || H)
  }, /* @__PURE__ */ n.createElement(Ee, oe)));
};
process.env.NODE_ENV !== "production" && (De.displayName = "Drawer");
const at = (e) => {
  var t, o;
  const {
    prefixCls: a,
    title: r,
    footer: l,
    extra: c,
    loading: d,
    onClose: v,
    headerStyle: h,
    bodyStyle: w,
    footerStyle: y,
    children: O,
    classNames: i,
    styles: m
  } = e, {
    drawer: s
  } = n.useContext(me), D = n.useCallback((p) => /* @__PURE__ */ n.createElement("button", {
    type: "button",
    onClick: v,
    "aria-label": "Close",
    className: `${a}-close`
  }, p), [v]), [$, P] = Qe(Ce(e), Ce(s), {
    closable: !0,
    closeIconRender: D
  }), _ = n.useMemo(() => {
    var p, C;
    return !r && !$ ? null : /* @__PURE__ */ n.createElement("div", {
      style: Object.assign(Object.assign(Object.assign({}, (p = s == null ? void 0 : s.styles) === null || p === void 0 ? void 0 : p.header), h), m == null ? void 0 : m.header),
      className: S(`${a}-header`, {
        [`${a}-header-close-only`]: $ && !r && !c
      }, (C = s == null ? void 0 : s.classNames) === null || C === void 0 ? void 0 : C.header, i == null ? void 0 : i.header)
    }, /* @__PURE__ */ n.createElement("div", {
      className: `${a}-header-title`
    }, P, r && /* @__PURE__ */ n.createElement("div", {
      className: `${a}-title`
    }, r)), c && /* @__PURE__ */ n.createElement("div", {
      className: `${a}-extra`
    }, c));
  }, [$, P, c, h, a, r]), b = n.useMemo(() => {
    var p, C;
    if (!l)
      return null;
    const M = `${a}-footer`;
    return /* @__PURE__ */ n.createElement("div", {
      className: S(M, (p = s == null ? void 0 : s.classNames) === null || p === void 0 ? void 0 : p.footer, i == null ? void 0 : i.footer),
      style: Object.assign(Object.assign(Object.assign({}, (C = s == null ? void 0 : s.styles) === null || C === void 0 ? void 0 : C.footer), y), m == null ? void 0 : m.footer)
    }, l);
  }, [l, y, a]);
  return /* @__PURE__ */ n.createElement(n.Fragment, null, _, /* @__PURE__ */ n.createElement("div", {
    className: S(`${a}-body`, i == null ? void 0 : i.body, (t = s == null ? void 0 : s.classNames) === null || t === void 0 ? void 0 : t.body),
    style: Object.assign(Object.assign(Object.assign({}, (o = s == null ? void 0 : s.styles) === null || o === void 0 ? void 0 : o.body), w), m == null ? void 0 : m.body)
  }, d ? /* @__PURE__ */ n.createElement(Ze, {
    active: !0,
    title: !1,
    paragraph: {
      rows: 5
    },
    className: `${a}-body-skeleton`
  }) : O), b);
}, $e = at, ot = (e) => {
  const t = "100%";
  return {
    left: `translateX(-${t})`,
    right: `translateX(${t})`,
    top: `translateY(-${t})`,
    bottom: `translateY(${t})`
  }[e];
}, Pe = (e, t) => ({
  "&-enter, &-appear": Object.assign(Object.assign({}, e), {
    "&-active": t
  }),
  "&-leave": Object.assign(Object.assign({}, t), {
    "&-active": e
  })
}), je = (e, t) => Object.assign({
  "&-enter, &-appear, &-leave": {
    "&-start": {
      transition: "none"
    },
    "&-active": {
      transition: `all ${t}`
    }
  }
}, Pe({
  opacity: e
}, {
  opacity: 1
})), rt = (e, t) => [je(0.7, t), Pe({
  transform: ot(e)
}, {
  transform: "none"
})], st = (e) => {
  const {
    componentCls: t,
    motionDurationSlow: o
  } = e;
  return {
    [t]: {
      // ======================== Mask ========================
      [`${t}-mask-motion`]: je(0, o),
      // ======================= Panel ========================
      [`${t}-panel-motion`]: ["left", "right", "top", "bottom"].reduce((a, r) => Object.assign(Object.assign({}, a), {
        [`&-${r}`]: rt(r, o)
      }), {})
    }
  };
}, lt = st, it = (e) => {
  const {
    borderRadiusSM: t,
    componentCls: o,
    zIndexPopup: a,
    colorBgMask: r,
    colorBgElevated: l,
    motionDurationSlow: c,
    motionDurationMid: d,
    paddingXS: v,
    padding: h,
    paddingLG: w,
    fontSizeLG: y,
    lineHeightLG: O,
    lineWidth: i,
    lineType: m,
    colorSplit: s,
    marginXS: D,
    colorIcon: $,
    colorIconHover: P,
    colorBgTextHover: _,
    colorBgTextActive: b,
    colorText: p,
    fontWeightStrong: C,
    footerPaddingBlock: M,
    footerPaddingInline: N,
    calc: k
  } = e, j = `${o}-content-wrapper`;
  return {
    [o]: {
      position: "fixed",
      inset: 0,
      zIndex: a,
      pointerEvents: "none",
      color: p,
      "&-pure": {
        position: "relative",
        background: l,
        display: "flex",
        flexDirection: "column",
        [`&${o}-left`]: {
          boxShadow: e.boxShadowDrawerLeft
        },
        [`&${o}-right`]: {
          boxShadow: e.boxShadowDrawerRight
        },
        [`&${o}-top`]: {
          boxShadow: e.boxShadowDrawerUp
        },
        [`&${o}-bottom`]: {
          boxShadow: e.boxShadowDrawerDown
        }
      },
      "&-inline": {
        position: "absolute"
      },
      // ====================== Mask ======================
      [`${o}-mask`]: {
        position: "absolute",
        inset: 0,
        zIndex: a,
        background: r,
        pointerEvents: "auto"
      },
      // ==================== Content =====================
      [j]: {
        position: "absolute",
        zIndex: a,
        maxWidth: "100vw",
        transition: `all ${c}`,
        "&-hidden": {
          display: "none"
        }
      },
      // Placement
      [`&-left > ${j}`]: {
        top: 0,
        bottom: 0,
        left: {
          _skip_check_: !0,
          value: 0
        },
        boxShadow: e.boxShadowDrawerLeft
      },
      [`&-right > ${j}`]: {
        top: 0,
        right: {
          _skip_check_: !0,
          value: 0
        },
        bottom: 0,
        boxShadow: e.boxShadowDrawerRight
      },
      [`&-top > ${j}`]: {
        top: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerUp
      },
      [`&-bottom > ${j}`]: {
        bottom: 0,
        insetInline: 0,
        boxShadow: e.boxShadowDrawerDown
      },
      [`${o}-content`]: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: l,
        pointerEvents: "auto"
      },
      // Header
      [`${o}-header`]: {
        display: "flex",
        flex: 0,
        alignItems: "center",
        padding: `${J(h)} ${J(w)}`,
        fontSize: y,
        lineHeight: O,
        borderBottom: `${J(i)} ${m} ${s}`,
        "&-title": {
          display: "flex",
          flex: 1,
          alignItems: "center",
          minWidth: 0,
          minHeight: 0
        }
      },
      [`${o}-extra`]: {
        flex: "none"
      },
      [`${o}-close`]: Object.assign({
        display: "inline-flex",
        width: k(y).add(v).equal(),
        height: k(y).add(v).equal(),
        borderRadius: t,
        justifyContent: "center",
        alignItems: "center",
        marginInlineEnd: D,
        color: $,
        fontWeight: C,
        fontSize: y,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        textDecoration: "none",
        background: "transparent",
        border: 0,
        cursor: "pointer",
        transition: `all ${d}`,
        textRendering: "auto",
        "&:hover": {
          color: P,
          backgroundColor: _,
          textDecoration: "none"
        },
        "&:active": {
          backgroundColor: b
        }
      }, Be(e)),
      [`${o}-title`]: {
        flex: 1,
        margin: 0,
        fontWeight: e.fontWeightStrong,
        fontSize: y,
        lineHeight: O
      },
      // Body
      [`${o}-body`]: {
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        padding: w,
        overflow: "auto",
        [`${o}-body-skeleton`]: {
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }
      },
      // Footer
      [`${o}-footer`]: {
        flexShrink: 0,
        padding: `${J(M)} ${J(N)}`,
        borderTop: `${J(i)} ${m} ${s}`
      },
      // ====================== RTL =======================
      "&-rtl": {
        direction: "rtl"
      }
    }
  };
}, ct = (e) => ({
  zIndexPopup: e.zIndexPopupBase,
  footerPaddingBlock: e.paddingXS,
  footerPaddingInline: e.padding
}), Re = Ae("Drawer", (e) => {
  const t = Ue(e, {});
  return [it(t), lt(t)];
}, ct);
var _e = function(e, t) {
  var o = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (o[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
      t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (o[a[r]] = e[a[r]]);
  return o;
};
const dt = {
  distance: 180
}, fe = (e) => {
  var t;
  const {
    rootClassName: o,
    width: a,
    height: r,
    size: l = "default",
    mask: c = !0,
    push: d = dt,
    open: v,
    afterOpenChange: h,
    onClose: w,
    prefixCls: y,
    getContainer: O,
    style: i,
    className: m,
    // Deprecated
    visible: s,
    afterVisibleChange: D,
    maskStyle: $,
    drawerStyle: P,
    contentWrapperStyle: _
  } = e, b = _e(e, ["rootClassName", "width", "height", "size", "mask", "push", "open", "afterOpenChange", "onClose", "prefixCls", "getContainer", "style", "className", "visible", "afterVisibleChange", "maskStyle", "drawerStyle", "contentWrapperStyle"]), {
    getPopupContainer: p,
    getPrefixCls: C,
    direction: M,
    drawer: N
  } = n.useContext(me), k = C("drawer", y), [j, Q, B] = Re(k), L = (
    // 有可能为 false，所以不能直接判断
    O === void 0 && p ? () => p(document.body) : O
  ), V = S({
    "no-mask": !c,
    [`${k}-rtl`]: M === "rtl"
  }, o, Q, B);
  if (process.env.NODE_ENV !== "production") {
    const W = Fe("Drawer");
    [["visible", "open"], ["afterVisibleChange", "afterOpenChange"], ["headerStyle", "styles.header"], ["bodyStyle", "styles.body"], ["footerStyle", "styles.footer"], ["contentWrapperStyle", "styles.wrapper"], ["maskStyle", "styles.mask"], ["drawerStyle", "styles.content"]].forEach((oe) => {
      let [X, T] = oe;
      W.deprecated(!(X in e), X, T);
    }), L !== void 0 && ((t = e.style) === null || t === void 0 ? void 0 : t.position) === "absolute" && process.env.NODE_ENV !== "production" && W(!1, "breaking", "`style` is replaced by `rootStyle` in v5. Please check that `position: absolute` is necessary.");
  }
  const H = n.useMemo(() => a ?? (l === "large" ? 736 : 378), [a, l]), ee = n.useMemo(() => r ?? (l === "large" ? 736 : 378), [r, l]), te = {
    motionName: be(k, "mask-motion"),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }, F = (W) => ({
    motionName: be(k, `panel-motion-${W}`),
    motionAppear: !0,
    motionEnter: !0,
    motionLeave: !0,
    motionDeadline: 500
  }), ne = Je(), [ae, g] = Ye("Drawer", b.zIndex), {
    classNames: I = {},
    styles: E = {}
  } = b, {
    classNames: z = {},
    styles: K = {}
  } = N || {};
  return j(/* @__PURE__ */ n.createElement(qe, {
    form: !0,
    space: !0
  }, /* @__PURE__ */ n.createElement(Ge.Provider, {
    value: g
  }, /* @__PURE__ */ n.createElement(De, Object.assign({
    prefixCls: k,
    onClose: w,
    maskMotion: te,
    motion: F
  }, b, {
    classNames: {
      mask: S(I.mask, z.mask),
      content: S(I.content, z.content),
      wrapper: S(I.wrapper, z.wrapper)
    },
    styles: {
      mask: Object.assign(Object.assign(Object.assign({}, E.mask), $), K.mask),
      content: Object.assign(Object.assign(Object.assign({}, E.content), P), K.content),
      wrapper: Object.assign(Object.assign(Object.assign({}, E.wrapper), _), K.wrapper)
    },
    open: v ?? s,
    mask: c,
    push: d,
    width: H,
    height: ee,
    style: Object.assign(Object.assign({}, N == null ? void 0 : N.style), i),
    className: S(N == null ? void 0 : N.className, m),
    rootClassName: V,
    getContainer: L,
    afterOpenChange: h ?? D,
    panelRef: ne,
    zIndex: ae
  }), /* @__PURE__ */ n.createElement($e, Object.assign({
    prefixCls: k
  }, b, {
    onClose: w
  }))))));
}, ut = (e) => {
  const {
    prefixCls: t,
    style: o,
    className: a,
    placement: r = "right"
  } = e, l = _e(e, ["prefixCls", "style", "className", "placement"]), {
    getPrefixCls: c
  } = n.useContext(me), d = c("drawer", t), [v, h, w] = Re(d), y = S(d, `${d}-pure`, `${d}-${r}`, h, w, a);
  return v(/* @__PURE__ */ n.createElement("div", {
    className: y,
    style: o
  }, /* @__PURE__ */ n.createElement($e, Object.assign({
    prefixCls: d
  }, l))));
};
fe._InternalPanelDoNotUseOrYouWillBeFired = ut;
process.env.NODE_ENV !== "production" && (fe.displayName = "Drawer");
const mt = fe, ft = Ve(vt)`
  ${({
  design: e
}) => e === "growfin_design_default" && pe`
      .ant-drawer-header {
        padding: 0;
        border-bottom-color: var(--gray-4);
      }
      .ant-drawer-footer {
        padding: 0;
        border-top: 0;
      }
    `}

  ${({
  design: e
}) => e === "close_position" && pe`
      .ant-drawer-close {
        order: 2;
        margin: 0;
        color: var(--primary-7);
      }
    `}
`;
function Nt(e) {
  return /* @__PURE__ */ Ne.jsx(ft, { closable: !1, ...e });
}
function vt(e) {
  return /* @__PURE__ */ Ne.jsx(mt, { ...e });
}
export {
  Nt as A,
  vt as D,
  ft as S
};
//# sourceMappingURL=AntDrawer-ChgesM8B.mjs.map
